import React, { FC } from 'react';

export interface StructuredVideoDataProps {
  video: {
    /** The url for the video content. */
    contentUrl?: string | null;
    /** The description given for the video. */
    description?: string | null;
    /** The the duration of the video. */
    duration?: string | null;
    /** The title for the video. */
    name?: string | null;
    /** The url address for the video thumbnail. */
    thumbnailUrl?: string | null;
    /** The upload date of the video. */
    uploadDate?: string | null;
  };
}

const StructuredVideoData: FC<StructuredVideoDataProps> = ({ video }) => {
  const defaults = {
    '@context': 'http://schema.org',
    '@type': 'VideoObject'
  };

  const schema = { ...defaults, ...video };

  // check if any required fields are missing
  if (
    !schema.description ||
    !schema.name ||
    !schema.thumbnailUrl ||
    !schema.uploadDate
  ) {
    return null;
  }

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema)
      }}
      type="application/ld+json"
    />
  );
};

export default StructuredVideoData;
export { StructuredVideoData };
